import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from 'reactstrap';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  property: any;
  onSave?: (newSupply: any) => void;
}

const EditSupplyModal: React.FC<Props> = ({ isOpen, toggle, property, onSave }) => {
  const [brokerId, setBrokerId] = useState(property?.broker_id ?? '');
  const [source, setSource] = useState(property?.source ?? '');

  useEffect(() => {
    setBrokerId(property?.broker_id ?? '');
    setSource(property?.source ?? '');
  }, [property]);

  const handleSave = () => {
    if (onSave) {
      onSave({ broker_id: brokerId, source });
    }
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Editar Supply</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="broker_id">Broker ID</Label>
          <Input
            id="broker_id"
            type="text"
            value={brokerId}
            onChange={e => setBrokerId(e.target.value)}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={!brokerId && !source}>
          Guardar
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditSupplyModal;